import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import {
  TRACK_EVENT_NAMES,
  TRACK_CATEGORIES,
  TRACK_LABELS,
} from 'lib/tracking';

import { AppStore } from 'stores/AppStore';

import { tabletUp, mobileOnly } from 'styles/utils';

import BrandLogo from '../BrandLogo/BrandLogo';
import BrandLogoIcon from '../Logos/BrandLogoIcon';
import Link from '../Link/Link';
import Breakpoint from '../Breakpoint/Breakpoint';

// Must be a function to work properly in SSR since `AppStore.isDipUti` is
// determined per request (on the server).
const logoCss = isDipUti => css`
  display: flex;

  ${mobileOnly} {
    width: ${isDipUti ? 80 : 100}px;
  }

  ${tabletUp} {
    width: ${isDipUti ? 134 : 149}px;
  }
`;

function NavbarLogo({ className = '', isMobileLogoIcon }) {
  return (
    <Link
      track={{
        event: TRACK_EVENT_NAMES.LOGO,
        category: TRACK_CATEGORIES.LOGO_CLICK,
        label: TRACK_LABELS.HEADER,
      }}
      css={logoCss(AppStore.isDipUti)}
      className={className}
      href="/"
      aria-label="Home"
    >
      <Breakpoint tablet desktop>
        <BrandLogo />
      </Breakpoint>

      <Breakpoint mobile>
        {isMobileLogoIcon ? <BrandLogoIcon /> : <BrandLogo />}
      </Breakpoint>
    </Link>
  );
}

NavbarLogo.propTypes = {
  className: PropTypes.string,
  /** Show a smaller logo on mobile */
  isMobileLogoIcon: PropTypes.bool,
};

export default NavbarLogo;
